import { IAction } from '~/src/store';

import { EPaymentActions } from './index';

export type TTogglePayWithBonusesStatus = IAction<EPaymentActions.TOGGLE_PAY_WITH_BONUSES, boolean>

const togglePayWithBonusesStatus = (isChecked: boolean): TTogglePayWithBonusesStatus => ({
    type: EPaymentActions.TOGGLE_PAY_WITH_BONUSES,
    payload: isChecked,
});

export default togglePayWithBonusesStatus;
